import { z } from 'zod'

import BackendContentType from 'common/builder/constants/BackendContentType'
import { LightFlowSchema } from 'shared/api/common/schemas/flow'
import { FlowSchema } from 'shared/api/common/schemas/flow/flow'

const FlowContentsSchema = z.array(
  z.object({
    type: z.nativeEnum(BackendContentType),
    content_id: z.number(),
    caption: z.string(),
    namespace: z.string(),
    deleted: z.boolean(),
    ts_created: z.number(),
    ts_updated: z.number(),
    data: z.object({}),
  }),
)

export const FlowApiSchemas = {
  getFlowContentData: {
    query: z.object({
      ns: z.string(),
    }),
    path: z.undefined(),
    response: z.object({
      flow: z.object({
        contents: FlowContentsSchema,
        root_content_id: z.number().nullable(),
        ns: z.string(),
        page_id: z.string(),
      }),
    }),
  },
  getFlow: {
    query: z.object({
      ns: z.string(),
      content_holder: z.string().optional(),
    }),
    path: z.undefined(),
    response: z.object({
      flow: LightFlowSchema,
    }),
  },
  getFlowData: {
    query: z.object({
      ns: z.string(),
      content_holder: z.string().optional(),
    }),
    path: z.undefined(),
    response: z.object({
      flow: FlowSchema,
    }),
  },
  setFlowName: {
    query: z.undefined(),
    request: z.object({
      ns: z.string(),
      name: z.string(),
    }),
    path: z.undefined(),
    response: z.object({
      flow: LightFlowSchema,
    }),
  },
  setFlowShared: {
    query: z.undefined(),
    request: z.object({
      ns: z.string(),
      shared: z.boolean(),
    }),
    response: z.object({
      flow: LightFlowSchema,
    }),
    path: z.undefined(),
  },
  setFlowSharedCloning: {
    query: z.undefined(),
    request: z.object({
      ns: z.string(),
      shared_cloning_enabled: z.boolean(),
    }),
    response: z.object({
      flow: LightFlowSchema,
    }),
    path: z.undefined(),
  },
  importSharedFlow: {
    path: z.object({
      pageId: z.string(),
    }),
    query: z.undefined(),
    request: z.object({
      share_hash: z.string(),
    }),
    response: z.object({
      flow: LightFlowSchema,
      path: z.string(),
    }),
  },
}
